import { withStyles } from '@material-ui/core';
import { inject } from 'mobx-react';
import { STOP_TYPE } from '../../../constants';
import ProNumberValue from './ProNumberValue';
import { withAppConfig } from '../../../../../../../appConfigContext';

const styles = (theme) => ({
  labelValue: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    wordBreak: 'break-word',
    width: '100%',
    cursor: "pointer"
  },
  label: {
    color: theme.iconColor,
    fontSize: 10,
    fontWeight: 400,
    textTransform: 'uppercase'
  }
});

const ProNumber = ({ classes, stopData, highlighted, route, DispatchStore, configJSON }) => {
  const staticClientStatusLists = DispatchStore
    ? {
        deliveryStatusList: DispatchStore.deliveryStatuses || [],
        exceptionList: DispatchStore.exceptions || [],
        returnCodeList: DispatchStore.returnCodes || []
      }
    : null;

  return (
    <>
      <div className={classes.label}>
        {stopData.stopType === STOP_TYPE.Pickup
          ? 'PICKUP NUMBER(S)'
          : 'PRO NUMBERS(S)'}
      </div>
      <div className={classes.labelValue}>
        <ProNumberValue
          stopData={stopData}
          highlighted={highlighted}
          route={route}
          staticClientStatusLists={staticClientStatusLists}
          enableReturnExceptionReasonLabels={Boolean(
            configJSON?.enableReturnExceptionReasonLabels
          )}
        />
      </div>
    </>
  );
};

export default inject('DispatchStore')(withAppConfig(withStyles(styles)(ProNumber)));
